import React from 'react';
import LanguageSelectorFooter from "./LanguageSelectorFooter";
import { CustomAccordion } from "./CustomAccordion";

const ProductAccordion = ({ items }) => {
    return (
        <div className="product-detail__accordion-container">
            {
                items.map((x, index) => {
                    return (<section className="product-detail__accordion-list" key={index}>
                            <CustomAccordion
                                key={index}
                                header={<h2
                                    className="product-detail__accordion-title accordion-toggle product-detail__accordion-item">{x.title}</h2>}
                                icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21"
                                         viewBox="0 0 20 21" fill="none">
                                        <path d="M5 8.06836L10 13.0684L15 8.06836" stroke="#373D41" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                }
                                content={
                                    <div className="product-detail__accordion-content">
                                        <table className="product-detail__specifications-table">
                                            <tbody>
                                            {
                                                x.fieldGroups.map((fieldGroup, fieldIndex) => {
                                                    return (<tr key={fieldIndex}>
                                                        {
                                                            x.type === 0 && <>
                                                                <td>
                                                                    <p className="product-detail__accordion-heading">{fieldGroup.name}</p>
                                                                </td>
                                                                <td>
                                                                    {fieldGroup.isRichText ?
                                                                        <div className="product-detail__accordion-text"
                                                                             dangerouslySetInnerHTML={{ __html: fieldGroup.value }}
                                                                        ></div> :
                                                                        <p className="product-detail__accordion-text">{fieldGroup.value}</p>
                                                                    }
                                                                </td>
                                                            </>
                                                        }
                                                        {
                                                            x.type === 1 && <>
                                                                <td>
                                                                    <a href={fieldGroup.url} download className="product-detail__accordion-text product-detail__accordion-text--link">{fieldGroup.name}</a>
                                                                </td>
                                                            </>
                                                        }
                                                        {
                                                            x.type === 2 && <>
                                                                <td>
                                                                    <a href={fieldGroup.url} download className="product-detail__accordion-text product-detail__accordion-text--link">
                                                                        <img src={fieldGroup.url} alt=""/>
                                                                    </a>
                                                                </td>
                                                            </>
                                                        }
                                                    </tr>);
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            >
                            </CustomAccordion>
                        </section>
                    )
                })
            }
        </div>
    );
};

export default ProductAccordion;
